import { h } from 'preact'; // h is required for JSX transform
import { OrthomolIcon } from '../../components-common/OrthomolIcon';
import { URLS } from '../Urls';

interface AboBenefitsListProps {
  deliveryText: string | null;
  showLink?: boolean;
}

export const AboBenefitsList = ({ deliveryText, showLink = true }: AboBenefitsListProps) => (
  <>
    <ul className="abo-info-tooltip-list">
      {deliveryText && (
        <li>
          <span className="purchase-option-check">
            <OrthomolIcon name="check-badge-16" size="16" viewBox="0 0 16 16" />
          </span>
          {deliveryText}
        </li>
      )}
      <li>
        <span className="purchase-option-check">
          <OrthomolIcon name="check-badge-16" size="16" viewBox="0 0 16 16" />
        </span>
        Gratis Versand für jede Lieferung (DE &amp; AT)
      </li>
      <li>
        <span className="purchase-option-check">
          <OrthomolIcon name="check-badge-16" size="16" viewBox="0 0 16 16" />
        </span>
        Du kannst die Lieferung jederzeit pausieren oder kündigen
      </li>
    </ul>
    {showLink && (
      <a href={URLS.aboInfo} className="purchase-option-link">
        Weitere Informationen
      </a>
    )}
  </>
);
